export const RouteType = {
  //login
  ADMIN: "/admin",
  AUTH: "/auth",
  LOGIN: "/login",
  USER: "/user",
  REGISTER: "/register",
  HOME: "/home",
  DASHBOARD: "/dashboard",
  MASTER: "/master",
  GET_COUNTRY: "/country-list",
  CURRENCY: "/currency",
  STORE: "/store",
  FILE: "/file-upload",
  DELETE: "/delete",
  UPDATE_CURRENCY_STATUS: "/update-currency-status",
  FEES_AND_CHARGE: "/fee-and-charges",
  SENDING_PURPOSE: "/sending-purpose",
  SOURCE_OF_FUND: "/source-of-fund",
  CHANGE_CURRENCY_STATUS: "/change-currency-status",
  CHANGE_FEES_AND_CHARGES_STATUS: "/change-fee-and-charges-status",
  CHANGE_SOURCE_OF_FUND_STATUS: "/change-source-of-fund-status",
  CHANGE_SENDING_PURPOSE_STATUS: "/change-sending-purpose-status",
  BANK: "/bank",
  CHANGE_BANK_STATUS: "/change-bank-status",
  GET_STATE: "/state-list",
  GET_CITY: "/city-list",
  GET_SENDING_PURPOSE: "/get-sending-purpose",
  GET_SOURCE_OF_FUND: "/get-source-of-fund",
  RECIPIENT: "/recipient",
  GET_CURRENCY: "/get-currency",
  USER_DETAILS: "userDetails",
  RESET_PASSWORD: "/reset-password",
  PROFILE_UPDATE: "/profile-update",
  CALCULATE_FEES_AND_CHARGES: "/cal-fee-charge",
  TOP_UP: "/topup",
  PAYIN_REQUEST: "/payin-request",
  TRANSCATION: "/get-transition",
  GET_BANK_BY_CURRENCY_ID: "/get-bank-by-currency-id",
  TOP_UP_DETAILS: "/topup",
  DEPOSIT_CURRENCY: "/deposite-currency",
  PAYMENT_STATUS: "/payIn_submission",
  TOP_UP_SUBMISSION: "/topup-submission",
  FAILED_PAYMENT: "/failed-payment",
  DEPOSIT_FAILED_PAYMENT: "/deposit-failed-payment",
  Balance: "/balance",
  RAMITTANCE_TRANSCATION: "/get-remitance-transition",
  RAMITTANCE_TRANSCATION_BY_ID: "/get-remitance-transition-by-id",
  CHECK_WALLET_BALANCE: "/check-wallet-balance",
  REMITTANCE: "/remittance",
  TRANSITION_COUNT: "/transitions-count",
  CHANGE_USER_STATUS: "/change-user-status",
  TRANSITION_GRAPH: "/transitions-graph",
  NOTIFICATION: "/notification",
  UNREAD_COUNT: "/unread-count",
  CHANGE_STATUS: "/change-status",
  CREATE_PASSWORD: "/update-password",
  FORGOT_PASSWORD: "/send-email",
  AIRPORT_LIST: "/airport-list",
  CREATE_USER: "/corporate-users",
  PERMISSION_LIST: "/permissions-list",
  USER_LIST: "/corporate-users",
  EDIT_USER: "/user-edit",
  COMPANY_LIST: "/business-list", //only company name
  USER_NAME: "/control-panel/name",
  BUSINESS_LIST: "/corporates", //comoany details
  CREATE_BUSINESS: "/control-panel/business-create", //comoany details
  EDIT_BUSINESS: "/control-panel/business-edit", //comoany details
  CONTROL_PANEL: "/control-panel",
  CREATE_ROLE: "/create-role",
  ROLE: "/role-name",
  // PERMISSION: "/permission-view",
  FLIGHT_LIST: "/flight-search",
  CALENDER_FARE: "/calender-search",
  AIR_RE_PRICE_RQ: "/AirRePriceRQ",
  COUNTRY_CODE: "/country-code",
  HOTEL_CITY: "/hotel-city",
  HOTEL_LIST: "/hotel-list",
  ADD_ON_SERVICES: "/flight-addon",
  HOTEL_INFO: "/hotel-info",
  COUPON_LIST: "/coupon-list",
  FUND: "/fund",
  HOLD: "/start-booking", //hold transaction
  CAPTURE: "/capture-booking",
  BOOKING_FAIL: "/booking-failed",
  FAIL_GATEWAY: "/gateway",
  ROOM_INFO: "/hotel-pro",
  CAPTURE_BOOKING: "/capture-booking",
  FLIGHT_BOOKING: "/flight-booking",
  HOTEL_BOOKING_LIST: "/hotel",
  // HOTEL_BOOKING: "/bookings/",
  APPLY_COUPON: "/apply-coupon",
  DOWNLOAD_INVOICE: "/flight/download-ticket/",
  COMMISSION: "/commission",
  FLIGHT_COMMISSION: "/flight-commissions",
  ADD_COMMISSION: "/flight-commission-categories",
  COMMISSION_RULE: "/bulk_create",
  CATEGORIES_LIST: "/flight-categories",
  HOTEL_CATEGORIES_LIST: "/hotel-commissions",
  CORPORATES: "/corporates",
  PERMISSIONS: "/menu",
  SIDE_MENU: "/menu",
  API: "/api",
  CALCULATE_COMMISSION: "/calculate_commission",
  COMMISSIONS: "/commission",
  EMAIL: "/send-email",
  BULK_UPDATE: "/bulk-update",
  TOPUP_REQUEST: "/topup-requests",
  TRANSITION: "/transition",
  AIRLINE: "/airlines",
  LOCATION: "/locations",
  COUNTRIES: "/countries",
  BY_COUNTRY: "/by-country",
  FLIGHT: "/flight",
  BOOKINGS: "/bookings",
  RESEND_TICKET: "/resend-ticket",
  COUPON: "/coupons",
  CREATE: "/create",
  Coupon_LIST: "/coupons",
  CHANGE_PASSWORD: "/update-password",
  ADMIN_USER: "/users",
  AVAILABLE_BALANCE: "/available-balance",
  CORPORATE_POSTPAID_ACCOUNT: "/fund/postpaid-accounts",
  CORPORATE_POSTPAID_ACCOUNT_LIST: "/fund/postpaid-accounts",
  HOTEL_TICKET: "/hotel/resend-ticket",
  ANALYTICS: "/analytics",
  CURRENCIES: "/currencies",
};
